import React from 'react';
import { useConfiguration } from "src/hooks/Configuration"
import { Image } from "../../styles"
import SpeakerModal from "../../../SpeakersWidget/modules/SpeakerModal";
import { useModal } from "src/hooks/Modal";
import { websitePath } from 'src/config';


const SpeakerImages = ({  program, component_styles}) => {

 
        const {addModal} = useModal();

   const openPopup = (content) => {
    
        addModal({
            title: '', content: <SpeakerModal component_styles={component_styles} content={content}/>, key: 'popupmodal', theme: 'whiteModalMedium'
        })

    }


    return <div className="row gap-xs">
        {program?.speakers?.map( speaker => {

return <div style={{position: 'relative'}}><Image className="scaleOnHover" onClick={() => {openPopup(speaker)}} src={`${websitePath}/${speaker?.photo}`} component_styles={component_styles}/>


{ speaker?.country_image ? <img src={`${websitePath}/${speaker?.country_image}`} style={{width: '20px', position:'absolute', bottom:'-10px', right: '5px', borderRadius:'3px'}}/> : <></>}

</div>




        })}

    </div>



}

export default SpeakerImages;